export default "__VITE_ASSET__DsX4uwvn__"